import React from 'react'
import Avatar from '../../../Assets/Image/avatar.png'
import { Link, useParams } from 'react-router-dom'
import { useState } from 'react'
import DeleteModal from './DeleteModal'

const LeftView = ({ company }) => {
  // Delete company modal state management
  const [deleteModal, setDeleteModal] = useState(false);
  const { companyid } = useParams();

  return (
    <div>
      <DeleteModal 
        open={deleteModal}
        close={() => setDeleteModal(false)}
      />
      <div className="TopDetails">
        <div className="Avatar">
          <img src={company?.logo_url?company?.logo_url:Avatar} alt='display pic' />
        </div>
        <h4 className="CompanyNameLabel">{company?.name} </h4>
        <p className="CompanyName">{company?.email} </p>
      </div>
      <div className="Mid_Section">
        <p className="Configure_text">Configuration</p>
        <Link to={`/configuration/${company?.id}`} >
          <button className="Configure_Btn">
            Edit
          </button>
        </Link>
      </div>
      <ul className="Bottom_Details">
        <li className="Box">
          <h4 className="Detail_label">Account ID</h4>
          <p className="Detail_value">ID-454534{`${companyid}`}</p>
        </li>
        <li className="Box">
          <h4 className="Detail_label">Company Email</h4>
          <p className="Detail_value">{company?.email} </p>
        </li>
        <li className="Box">
          <h4 className="Detail_label">Company Address</h4>
          <p className="Detail_value">{company?.location} </p>
        </li>
        {/* <li className="Box">
          <h4 className="Detail_label">Last Login</h4>
          <p className="Detail_value">April 25 2023</p>
        </li> */}
        <li className="Box">
          <h4 className="Detail_label">Language</h4>
          <p className="Detail_value">English</p>
        </li>
      </ul>
      <div className="Btn_Delete">
        <button onClick={() => setDeleteModal(true)} >
          Remove Company
        </button>
      </div>
    </div>
  )
}

export default LeftView